import {hMacAjax} from 'grt-tool-lib-front';
import {systemAPI, userCenterAPI} from '@/httpService/serviceApi';

interface genUrlResult {
    success: boolean;
    data: string | undefined | null;
}

export let URL = {
    taskList: `${systemAPI}/sync/task/list`,
    obsSignUrl: `${userCenterAPI}/open/aliyun/oss/v1/temp/url`
};

//通过组织名称组织树列表
export async function handleDownloadTaskList() {
    return hMacAjax.get(URL.taskList);
}

export const getDownloadSignUrl = async (bucket_name: string, object_key: string): Promise<genUrlResult> => {
    try {
        const result: Response = await fetch(URL.obsSignUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                bucket_name,
                object_key,
                method: 'GET'
            })
        });
        return result.json().then((res) => {
            const {success, data} = res;
            if (!success) return {success: false, data: null};
            return {success: true, data};
        });
    } catch (error) {
        return {success: false, data: JSON.stringify(error)};
    }
};
